// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3wyyt","signatureButtonsRight":"ModalSign_signatureButtonsRight__4mC5D"};